import React from "react";
import { LicensesBillingStatuses } from "../../constants/licenses";
import { concatTime, calculateDiffDays } from "../../utils/date";
import { cn } from "../../lib/utils";

export function LicenseBillingStatus({ license, descriptive = false, withBackground = true, ...props }) {
   if (!license) {
      return;
   }
   if (!license.currentBilling) {
      return (
         <span className="opacity-40 text-xs!">
            Indefinido
         </span>
      );
   }
   const dueDate = new Date(concatTime(license.currentBilling.dueDate));
   const diffDays = calculateDiffDays(new Date(), dueDate);
   let billingStatusKey = license.currentBilling.status;

   if (billingStatusKey !== 'PAID') {
      if (diffDays < 0) {
         billingStatusKey = 'OVERDUE';
      } else if (diffDays < 10) {
         billingStatusKey = 'EXPIRING';
      }
   }
   const billingStatus = LicensesBillingStatuses[billingStatusKey];

   return (
      <span className={cn("relative inline-flex items-center text-(--statusColor)! font-semibold px-3! py-2! pr-4!", props.className)} style={{ '--statusColor': billingStatus.color }}>
         {withBackground && (
            <span className="absolute z-10 size-full bg-(--statusColor)! opacity-10 inset-0 rounded-full"></span>
         )}
         <span className="relative z-20 inline-flex flex-license gap-1 items-center">
            {billingStatus.icon && (
               <>
                  {React.createElement(billingStatus.icon, { size: 16 })}
               </>
            )}
            {(descriptive ? billingStatus.descriptive : billingStatus.name) ?? billingStatus.name}{billingStatusKey === 'EXPIRING' ? ` em ${Math.abs(diffDays)} dias` : ''}
         </span>
      </span>
   );
}